import styled from '@emotion/styled';
import { type IndividualUserInviteErrorResponse } from '../types';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';

const StyledList = styled('ul')(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

type SharingErrorListProps = {
  failedUserInvitations: [string, IndividualUserInviteErrorResponse][];
};

const SharingErrorList = ({ failedUserInvitations }: SharingErrorListProps) => (
  <StyledList>
    {failedUserInvitations.map(([email, { challengeSharingResult }]) => (
      <li key={email}>
        <strong>{email}</strong>:{' '}
        <FormattedMessageWithChallengeNaming
          id={`portfolio.challenge.sharing.error_dialog.error_texts.${challengeSharingResult.toLowerCase()}`}
        />
      </li>
    ))}
  </StyledList>
);
export default SharingErrorList;
